import { useAxios } from "@/services"
import { URL_PREFIX } from "@/services"

// 获取验证码
export const getVerificationCode = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/sms/register`,
		method: "post",
		data: data
	}).run()

export const wxLogin = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/wxmp/login`,
		method: "post",
		data: data
	}).run()

// 开发阶段取token
export const getMockToken = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/mock/token`,
		method: "get",
		params,
	}).run()

export const getWxToken = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/wxmp/token`,
		method: "post",
		data: data
	}).run()

// 绑定学生账号
export const postStudentBind = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/bind`,
		method: "post",
		data: data
	}).run()

// 绑定学生账号
export const parentWinsIsAdmin = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/parentWinsIsAdmin`,
		method: "post",
		data: data
	}).run()

// 绑定学生账号前校验
export const getVerifyImg = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/getVerifyImg`,
		method: "get",
		params
	}).run()

// 家长角色列表
export const getParentRoles = () =>
	useAxios({
		url: `${URL_PREFIX}/parent/roles`,
		method: "get"
	}).run()

// 查询绑定的学生列表
export const getStudentAll = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/all`,
		method: "get",
		params,
	}).run()

	// 解绑学生账号（批量）
export const postStudentUnbind = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/unbind`,
		method: "post",
		data,
	}).run()

// 申请记录-当前学生账号的绑定申请列表
export const applyList = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/apply/list`,
		method: "get",
		params,
	}).run()
// 申请记录-处理绑定申请
export const applyDeal = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/apply/deal`,
		method: "post",
		data,
	}).run()

export const jsapiSignature = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/wxmp/jsapiSignature`,
		method: "post",
		data,
	}).run()

// 查询绑定的家长列表
export const getParentList = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/parents`,
		method: "get",
		params,
	}).run()

// 移除成员
export const removeMember = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/remove`,
		method: "post",
		data,
	}).run()

export const studentInfo = (studentId: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/` + studentId,
		method: "get",
	}).run()

// 申请记录-我收到的
export const receiveRecords = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/apply/receive`,
		method: "get",
		params,
	}).run()

// 申请记录-我发出的
export const sendRecords = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/apply/send`,
		method: "get",
		params,
	}).run()

// 移交管理员
export const turnAdmin = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/management/turnAdmin`,
		method: "post",
		data,
	}).run()

// 切换学生
export const postStudentChange = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/student/change`,
		method: "post",
		data,
	}).run()

// 查询当前登录人（家长）信息
export const getParentMine = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/parent/mine`,
		method: "get",
		params,
	}).run()

// 视力保护配置列表
export const getConfigList = (data: any) =>
	useAxios({
		url: `/english-parent-web/eyesSaver/config/list`,
		method: "post",
		data,
	}).run()

// 视力保护获取列表中有没有i3系统孩子
export const getVisionprotectioni3List = (data: any) =>
	useAxios({
		url: `/english-parent-web/eyesSaver/config/switch/i3`,
		method: "post",
		data,
	}).run()

// 保存视力保护配置
export const saveConfigList = (data: any) =>
	useAxios({
		url: `/english-parent-web/eyesSaver/config/save`,
		method: "post",
		data,
	}).run()

// 清除密保
export const updateQuestionStatus = (data: any) =>
	useAxios({
		url: `/english-parent-web/student/updateQuestionStatus`,
		method: "post",
		data,
	}).run()

// 获取Pad头像
export const getImgUrl = (data: any) =>
	useAxios({
		url: `/english-parent-web/student/get`,
		method: "post",
		data,
	}).run()

// 修改pad头像
export const updatePortrait = (data: any) =>
	useAxios({
		url: `/english-parent-web/student/updatePortrait`,
		method: "post",
		data,
	}).run()

// 查询管控
export const getControlTime = (params: any) =>
	useAxios({
		url: `${URL_PREFIX}/student/math/controlTime/getById`,
		method: "get",
		params,
	}).run()

// 修改管控
export const updateControlTime = (data: any) =>
	useAxios({
		url: `${URL_PREFIX}/student/math/controlTime/update`,
		method: "post",
		data,
	}).run()


